/*
 * Copyright (c) 2017-2018. Code réalisé par IpsoSenso
 */

import { flatten } from 'flat'
import { ACTION_TYPE, CUSTOMER_SATISFACTION, FORECAST_PROBABILITY, MANUALLY_CLOSED_STATUS, CONTRACT_MODULE, VIEW, MONTH } from '../enums'
import { LEVEL } from '../constants'

export default flatten({
	title: 'RTV-TOOL German',
	menu: {
		retour: 'Zurück zur Anwendung',
		countries: 'Länder verwalten',
		renegotiation: 'Renegotiation heatmap',
		users: 'Benutzer verwalten',
		import: 'Benutzer importieren',
	},
	renegotiation : {
		message : 'Jede Zelle auf der Grundlage der Verkaufspolitik anpassen',
		risk_score: 'Contract risk score',
		price_score: 'Contract price score',
		dialog: {
			title: 'Neuverhandlungsprinzip für die Punktzahl {risk}/{price}',
			tip: 'Tip',
			cancel: 'Abbrechen',
			update: 'Aktualisieren'
		}
	},
	searchBar: 'Zum Vertrag wechseln, SV-Verk....',
	login: {
		button: 'Mit Microsoft-Profil einloggen',
		error: 'Ihr Konto gewährt Ihnen keinen Zugriff auf diese App',
	},
	layout: {
		dashboard: 'Team-Dashboard',
		srOverview: 'SV-Verk. – Übersicht',
		contractsOverview: 'Vertragsübersicht',
		portfolio: 'Mein Portfolio',
		actions: 'Aktionsübersicht',
		forecasts: 'Prognoseübersicht',
		reporting: {
			label: 'User reporting',
			teams: 'Teams',
			detailed: 'Monthly Reporting'
		},
		notifications: {
			help: {
				title: 'Hilfe erforderlich',
				noContract: 'Kein Vertrag, der Hilfe benötigt',
				needHelp: '{firstName} {lastName} benötigt Hilfe zu:{CustomerName} ({id})',
			},
			overdueContracts: {
				title: 'Überfällige Verträge',
				noContract: 'Kein überfälliger Vertrag',
				contract: '{CustomerName} ({id}) in der Prioritätenliste seit {nbMonths} Monaten',
			},
			overdueActions: {
				title: 'Überfällige Maßnahmen',
				noAction: 'Keine überfällige Aktion',
				action: '{CustomerName} ({idContract}):Aktion geplant am {deadline}',
			},
		},
		logout: 'Abmelden',
	},
	search: {
		contracts: {
			title: 'Verträge',
			noResult: 'Kein Ergebnis gefunden',
		},
		salesRepresentative: {
			title: 'SV-Verk.',
			noResult: 'Kein Ergebnis gefunden',
		},
	},
	pages: {
		selectCountry: {
			title: 'Wählen Sie ein Land oder eine Region aus',
			indicators: {
				withoutActions: 'Verträge ohne Maßnahmen',
				withActions: 'Verträge mit Maßnahmen',
				overdue: 'Verträge überfällig',
				closed: 'Abgeschlossene Maßnahmen'
			},
			button: 'Team-Dashboard',
			seeReporting: 'See reporting',
			backToHomePage: 'Back to home page'
		},
		portfolio: {
			title: 'Mein Portfolio',
			breadcrumbs: 'Mein Portfolio',
			tabBar: {
				priority: 'Prioritätenliste',
				monthly: 'Prioritäten aktueller Monat',
				all: 'Alle Verträge',
				allDetails: 'Alle Details',
			},
		},
		contractsOverview: {
			title: 'Vertragsübersicht',
			breadcrumbs: {
				dashboard: 'Team-Dashboard',
				contractsOverview: 'Vertragsübersicht',
			},
			tabBar: {
				priority: 'Prioritätenliste',
				cancelled: 'Zuletzt gekündigke Verträge',
				all: 'Alle Verträge',
			},
			filters: {
				title: 'Filter',
				help: 'Wählen Sie ein oder mehrere Elemente in einer oder mehreren Spalten aus, um die Verträge anzuzeigen, die Ihrer Auswahl entsprechen.',
				reset: 'Filter zurücksetzen',
				apply: 'Übernehmen',
				headers: {
					status: 'Vertragsstatus',
					classification: 'Klassifizierung',
					risk: 'Risikoindikator',
					value: 'Wertanzeige',
					flags: 'Alarmmeldungen',
					endDate: 'Vertragsende',
					riskTypology: 'Risikotyp',
					customerFeedback: 'Kundenfeedback',
				},
				status: {
					toDo: 'KEINE AKTION',
					inProgress: 'WIRD AUSGEFÜHRT',
					toBeCancelled: 'WIRD VERHANDELT',
					toBeExtended: 'WIRD VERLÄNGERT',
					renegociated: 'NEU VERHANDELT',
					upgraded: 'AKTUALISIERT',
					downgraded: 'HERUNTERGESTUFT',
				},
				classification: {
					high: 'Hoher Wert/Risiko',
					low: 'Niedriger Wert',
					manually: 'Manuell hinzugefügt',
				},
				risk: {
					1: '1 - Niedrig',
					2: '2 - Niedrig',
					3: '3 - Mittel',
					4: '4 - Mittel',
					5: '5- Hoch',
				},
				value: {
					0: '0 - Negativ',
					1: '1 - Niedrig',
					2: '2 - Niedrig',
					3: '3 - Mittel',
					4: '4 - Mittel',
					5: '5 - Hoch',
				},
				flags: {
					help: 'Hilfe erforderlich',
					overdue: 'Überfällig',
					actionsOverdue: 'Maßnahmen überfällig',
				},
				endDate: {
					outdated: 'Abgelaufen',
					short: '< 3 Monate',
					medium: '3 - 6 Monate',
					long: '> 6 Monate',
				},
				riskTypology: {
					field: 'Field',
					sales: 'Vertrieb',
				},
				customerFeedback: {
					cancellationLetter: 'Kündigungsschreiben erhalten',
					claimLetter: 'Antragsschreiben eingegangen (12 Monate)',
				},
			},
			sorts: {
				title: 'Sortieren nach',
				priority: {
					label: 'Priorität (Standard)',
					labelShort: 'Priorität',
				},
				risk: {
					label: 'Risiko',
					labelShort: 'Risiko',
				},
				value: {
					label: 'Wert',
					labelShort: 'Wert',
				},
				endDate: {
					label: 'Vertragsende',
					labelShort: 'Enddatum',
				},
				unitsNumber: {
					label: 'Unitnummer',
					labelShort: 'Units',
				},
			},
			table: {
				searchBar: {
					classic: 'Suche nach SV-Verk., Kunde oder Vertrags-ID',
					[CONTRACT_MODULE.FR]: 'Suche nach SV-Verk., Vorgesetzter, Mechaniker, Kunde,Vertrags-ID oder -Adresse',
				},
				headers: {
					contract: {
						title: 'Vertrag',
						cancelled: {
							title: 'Gekündigt',
							tooltip: 'Vertrag in CRM/BFO gekündigt',
						},
						needHelp: {
							title: 'Hilfe erforderlich',
						},
					},
					status: {
						title: 'Aktionsstatus',
						notPriority: {
							title: 'Vertrag ohne Priorität',
							tooltip: '"Um Maßnahmen für diesen Vertrag zu verwalten, sehen Sie sich die Vertragsdetails an und verwenden Sie die Aktion ""Zur Prioristenliste hinzufügen"""',
						},
					},
					actionsOpened: 'Maßnahmen eingeleitet',
					valueIndicator: {
						title: 'Wert',
						tooltip: 'Wertanzeige : {Indikator}/5 (0 = negativer Wert)',
					},
					riskIndicator: {
						title: 'Risiko',
						tooltip: 'Risikoindikator:{indicator}/5',
					},
					riskTypology: {
						title: 'Risikotyp',
						flag: {
							sales: 'Details zu Sales-Alarmmeldungen',
							field: 'Details zu Feldmarkierungen',
						},
					},
					endDate: {
						title: 'Vertragsende',
						tooltip: {
							desktop: 'Prioritätsvertrag nach 3 Monaten nicht abgeschlossen',
							mobile: 'Vertrag noch offen',
							contractEndTypology: 'Art des Vertragsendes: ',
							requestedCancellationDate: 'Gewünschtes Kündigungsdatum: ',
						},
					},
					unitsNumber: {
						title: 'Units',
						tooltip: 'Verkaufspreis:',
					},
					advancedNoticePeriodDate: 'Kündigungsfrist',
				},
				noResult: 'Keine Verträge gefunden',
				loading: 'Verträge werden geladen',
				show: 'Vertrag anzeigen',
			},
			otherContract: {
				title: 'Andere Verträge',
				contracts: 'Verträge',
				salesRep: 'SV-Verk.',
				portfolio: 'Mein Portfolio',
			},
			otherSR: {
				title: 'Andere/r SV-Verk.',
				noResult: 'Kein(e) andere(r) SV-Verk. gefunden',
				headers: {
					sales: 'SV-Verk.',
					contracts: 'Verträge',
				},
			},
		},
		salePortfolioManager: {
			breadcrumbs: {
				dashboardRegional: 'Dashboard für Regionen',
				dashboard: 'Team-Dashboard',
				srOverview: 'SV-Verk.-Übersicht',
				srPortfolio: 'Portfolio von {firstName} {lastName}',
				portfolio: 'Portfolio',
			},
			title: {
				srPortfolio: 'Portfolio von {firstName} {lastName}',
				portfolio: 'Portfolio',
			},
		},
		contract: {
			comparison: {
				hide: 'Ausblenden',
				show: 'Anzeigen',
				text: 'Preisvergleich unter ähnlichen Verträgen',
				tooltip: 'Gibt Aufschluss über die Vertragsposition im Vergleich zu anderen Verträgen mit ähnlichen Merkmalen (Unit, Vertrag und Kundentyp...) im Portfolio.',
				chart: {
					price: 'Vertragspreis',
					value: 'Vertragswert',
				},
				portfolioValue: 'Portfoliowachstum (laufendes Jahr): ',
			},
			risk: {
				close: {
					title: 'Risiko manuell minimieren',
					outcome: {
						title: 'Ergebnis',
						to_be_autorenewed: {
							label: 'Wird verlängert',
							detail: '(Vertrag wird automatisch verlängert)',
						},
						to_be_cancelled: {
							label: 'Wird gekündigt',
							detail: '(Wird gekündigt. Keine Möglichkeit, den Vertrag zu verlängern)',
						},
						renegotiated: {
							label: 'Neuverhandlung abgeschlossen',
							detail: '(Neu verhandelt, Vertragspreis unverändert)',
						},
						upgraded: {
							label: 'Upselling abgeschlossen',
							detail: '(Neu verhandelt, höherer Vertragspreis)',
						},
						downgraded: {
							label: 'Downselling abgeschlossen',
							detail: '(Neu verhandelt mit niedrigerem Vertragspreis)',
						},
					},
					comment: 'Kommentar',
					cancel: 'Abbrechen',
					button: 'Risiko manuell minimieren',
					errors: {
						required: 'Erforderlich',
						mandatory: 'Obligatorische Informationen',
					},
				},
			},
			charts: {
				range: 'Bereich: {rangeMin} {currency} - {rangeMax} {currency}',
				median: 'Median: {median} {currency}',
			},
			flags: {
				description: {
					ContractAge: 'Vertragsalter: der Vertrag ist in den 20 % der ältesten Verträge',
					ContractDuration: 'Vertrag nicht automatisch verlängert: Verträge mit Enddatum < 6 Monate',
					Public: 'Öffentlicher Vertrag: Kunde ist eine juristische Person des öffentlichen Rechts',
					CustomerType: 'Kundentyp: Kunde, der gerne neu verhandelt',
					NationalAccount: 'Key Account: Kunde ist ein Key Account',
					Recovery: 'Vertrag zurückgewonnen: Vertrag wurde ursprünglich vom Wettbewerb zurückgewonnen',
					SellingPrice: 'Hoher Preis pro Unit: der Vertrag liegt in den Top 20% der höchsten Preise pro Unit',
					ContractValue: 'Hoher Preis pro Unit: der Vertrag liegt in den Top 20% der höchsten Wertigkeit pro Unit',
					Units: 'Hohe Unit-Anzahl: der Vertrag liegt in den Top 20% der Verträge mit der höchsten Anzahl von Units',
					Rebel: 'Hoher Anteil an Rebel-Units: der Vertrag liegt in den Top 20% der Rebel-Units der letzten 12 Monate',
					Callbacks: 'Erhöhtes Störungsaufkommen: der Vertrag liegt in den Top 20% der Verträge mit den meiesten Stöungen in den letzten 12 monaten',
					ResponseTime: 'Hohe Reaktionszeiten: die durchschnittliche Reaktionszeit pro Unit liegt in den Top 20% der Units mit den höchsten Reaktionszeiten in den letzten 12 Monaten',
					Availability: 'Geringere Verfügbarkeit: der Vertrag lag in den letzten 12 Monaten um 20 % unter der Verfügbarkeit',
					MissedMaintenance: 'Versäumte Wartung: der Vertrag liegt in den Top 20% der versäumten Wartungsmaßnahmen am häufigsten',
					Trapped: 'Eingeschlossene Personen: der Vertrag ist in den Top 20% der Verträge mit den meisten eingeschlossenen Personen der letzten 12 Monate',
				},
				close: 'Schließen',
			},
			breadcrumbs: {
				dashboardRegional: 'Dashboard für Regionen',
				dashboard: 'Team-Dashboard',
				srOverview: 'SV-Verk.-Übersicht',
				srPortfolio: 'Portfolio von {firstName} {lastName}',
				contract: '{name} ({contractId})',
				myPortfolio: 'Mein Portfolio',
			},
			actions: {
				close: 'Risiko minimieren',
				add: 'Zur Prioritätenliste hinzufügen',
				help: {
					title: 'Hilfe vom Vorgesetzten anfordern',
					tooltip: 'Bitten Sie den Niederlassungsleiterum Hilfe',
				},
			},
			information: {
				title: 'Informations- und Risikomanagement',
				status: {
					TODO: 'KEINE MASSNAHME',
					IN_PROGRESS: 'WIRD BEARBEITET',
					TO_BE_CANCELLED: 'WIRD GEKÜNDIGT',
					TO_BE_AUTO_RENEWED: 'WIRD VERLÄNGERT',
					RENEGOTIATED: 'NEU VERHANDELT',
					UPGRADED: 'AKTUALISIERT',
					DOWNGRADED: 'HERUNTERGESTUFT',
					CLOSED_AUTOMATICALLY: 'WIRD VERLÄNGERT'
				},
				headers: {
					contractValue: {
						title: 'Vertragswert',
						tooltip: 'O jährlicher Rechnungswert + durchschnittlicher T-Umsatz < 5Kâ‚¬ der letzten 3 Jahre',
					},
					customerIdCrm: "Kunden-Nr",
					value: 'Wert',
					riskTypology: {
						title: 'Risikotyp',
						flags: {
							sales: {
								title: 'Details zu Sales-Alarmmeldungen',
								name: 'Vertrieb',
							},
							field: {
								title: 'Details zu Field-Details',
								name: 'Field',
							},
						},
					},
					units: 'Units',
					price: {
						title: 'Wartungspreis',
						tooltip: 'O Jahrespreis',
					},
					risk: 'Risiko',
					callbacks: 'Störungsmeldungen',
					endDate: 'Vertragsende',
					invoicesValue: 'Höhe der offenen Rechnungen',
					address: 'Kundenanschrift',
					renegotiationTip: {
						header: 'Neuverhandlung prinzip',
						dialogTitle : 'Neuverhandlungsprinzip für diesen Vertrag',
						noTip: 'Dieser Vertrag ist nicht fakturierbar und wird mit Sicherheit gekündigt',
						outlier: 'Dieser Vertrag ist sehr spezifisch und bedarf im Falle einer Neuverhandlung der Zustimmung der Geschäftsleitung'
					}
				},
				closed: {
					button: 'Risiko erneut öffnen',
					text: 'Das Risiko wurde am {date} durch {firstName} {lastName} minimiert',
					textAuto: 'Das Risiko wurde am {date} automatisch minimiert'
				},
				comment: 'Kommentar',
				dialog: {
					error: {
						title: 'Risiko kann nicht minimiert werden',
						text: 'Alle Ma?nahmen müssen abgeschlossen werden, bevor das Risiko minimiert wird.',
						close: 'Schließen',
					},
					notAvailable: {
						title: 'Maßnahme nicht verfügbar',
						text: 'Nur Ihr Vorgesetzter kann das Risiko erneut erhöhen',
						cancel: 'Schließen',
					},
					reOpen: {
						title: 'Bestätigung der erneuten Erhöhung des Risikos',
						text: 'Risiko erneut erhöhen? (Vorherige Ergebnisse und Kommentare werden gelöscht)',
						confirm: 'Risiko erneut erhöhen',
					},
					addPriority: {
						title: 'Zur Prioritätenliste hinzufügen',
						text: 'Diesen Vertrag zur Prioritätenliste hinzufügen ?',
						confirm: 'Vertrag hinzufügen',
						cancel: 'Schließen',
					},
				},
				tabs: {
					tab: {
						details: 'Vertragsdetails',
						actions: 'Maßnahmen',
						zeroAction: 'Ergreifen Sie Ihre erste Maßnahme',
					},
					detailsTab: {
						moduleFrance: {
							advancedNoticePeriodDate: 'Kündigungsfrist',
							contractCategory: 'Vertragstyp',
							requestedCancellationDate: 'Gewünschtes Kündigungsdatum',
							claimLettersNb: 'Anzahl der erhaltenen Mahnungen',
							supervisorName: 'Name des Vorgesetzten',
							mechanicName: 'Name des Monteurs',
							customerSatisfactionLvl: {
								title: 'Kundenzufriedenheit',
								[CUSTOMER_SATISFACTION.UNSATISFIED]: 'Unzufrieden',
								[CUSTOMER_SATISFACTION.SATISFIED]: 'Zufrieden',
							},
							contractEndTypology: 'Art des Vertragsendes',
						},
						comments: {
							empty: 'Es wurde kein Kommentar abgegeben',
							lastModified: 'Zuletzt geändert am {date} von {firstName} {lastName}',
							updateComment: 'Kommentar aktualisieren',
							managersTitle: 'Kommentar des Vorgesetzten',
							srTitle: 'Kommentar des SV-Verk.',
							dialog: {
								comment: 'Kommentar',
								cancel: 'Abbrechen',
								update: 'Aktualisieren',
							},
						},
					},
				},
			},
			forecast: {
				title: 'Kündigungsprognose',
				probability: {
					label: 'Wahrscheinlichkeit',
					high: 'Hohe Wahrscheinlichkeit',
					low: 'Geringe Wahrscheinlichkeit',
				},
				cancellationMonth: {
					label: 'Kündigungsmonat',
				},
				save: 'Prognose speichern',
				errors: {
					required: 'Erforderlich',
					outdated: 'Abgelaufene Prognose',
				},
				snackbar: {
					success: 'Prognose hinzugefügt',
					error: 'Fehler beim Hinzufügen',
				},
			},
		},
		dashboard: {
			title: 'Team-Dashboard - {level}',
			branch: {
				table: {
					titleNational: 'Offene Verträge in den Ländern',
					titleRegion: 'Offene Verträge in der Region',
					headers: {
						branchName: 'Niederlassung',
						todo: 'Offene Verträge ohne Aktionen',
						inProgressCount: 'Verträge mit offenen Maßnahmen',
						closedCount: 'Abgechlossene Verträge',
					},
					noResult: 'Keine Niederlassung gefunden',
				},
			},
			region: {
				table: {
					title: 'Offene Verträge in der Region',
					headers: {
						regionName: 'Region',
						todo: 'Offene Verträge ohne Maßnahmen',
						inProgressCount: 'Verträge mit offenen Maßnahmen',
						closedCount: 'Verträge abgearbeitet',
					},
					noResult: 'Keine Regionen gefunden',
				},
			},
			highRisk: {
				table: {
					title: 'Verträge mit hohem Wert / hohem Risiko',
					headers: {
						contract: 'Vertrag',
						actionsOpened: 'Maßnahmen eingeleitet',
						valueIndicator: 'Wert',
						riskIndicator: 'Risiko',
					},
					tooltip: {
						value: 'Wertanzeige : {indicator}/5 (0 = negativer Wert)',
						risk: 'Risikoindikator : {indicator}/5',
					},
					noResult: 'Keine Verträge gefunden',
				},
				button: 'Alle Verträge anzeigen (monatliche Besprechung)',
			},
			priorityOpenContracts: {
				title: 'Offene Verträge mit Priorität',
				indicators: {
					srNeedHelp: 'SV-Verk. benötigt Hilfe',
					contractionWithActionsOverdue: 'Verträge mit überfälligen Maßnahmen',
					contractsOverdue: 'Überfällige Verträge',
				},
				button: 'Alle Verträge anzeigen',
				contracts: 'Verträge',
			},
			salesRep: {
				title: {
					national: 'Großkunden',
					openContracts: 'Offene Verträge',
				},
				table: {
					headers: {
						lastName: 'SV-Verk.',
						todo: 'Offene Verträge ohne Maßnahmen',
						inProgress: 'Verträge mit offenen Maßnahmen',
						closed: 'Verträge abgearbeitet',
					},
					noResult: 'Keine SV-Verk. gefunden',
				},
				button: 'Alle VertriebsmitarbeiterInnen anzeigen',
			},
			topPriorityContracts: {
				title: 'Verteilung von Verträgen mit höchster Priorität',
				tooltip: '{nb} Verträge',
				type: {
					noAction: 'Keine Maßnahme',
					inProgress: 'Wird Ausgeführt',
					manuallyClosed: 'Manuell geschlossen',
				},
			},
			manuallyClosedContracts: {
				title: 'Abgeschlossene Prioritätsverträge',
				tooltip: 'Manuell geschlossene Statusverteilung (CRM/BFO-Kündigungsstatus wird nicht berücksichtigt)',
				headers: {
					all: 'Alle Verträge',
					high: 'Hoher Wert/Risiko',
					low: 'Niedriger Wert',
				},
				rows: {
					[MANUALLY_CLOSED_STATUS.TO_BE_CANCELLED]: {
						title: 'Wird gekündigt',
						tooltip: 'Wird gekündigt. Keine Möglichkeit, den Vertrag zu verlängern',
					},
					[MANUALLY_CLOSED_STATUS.TO_BE_AUTO_RENEWED]: {
						title: 'Wird verlängert',
						tooltip: 'Der Vertrag wird automatisch verlängert',
					},
					[MANUALLY_CLOSED_STATUS.RENEGOTIATED]: {
						title: 'Neuverhandlung abgeschlossen',
						tooltip: 'Neu verhandelt, Vertragspreis unverändert',
					},
					[MANUALLY_CLOSED_STATUS.UPGRADED]: {
						title: 'Upselling abgeschlossen',
						tooltip: 'Neu verhandelte Verträge mit erhöhtem Vertragswert',
					},
					[MANUALLY_CLOSED_STATUS.DOWNGRADED]: {
						title: 'Downselling abgeschlossen',
						tooltip: 'Neu verhandelt mit niedrigerem Vertragspreis',
					},
				},
			},
		},
		srPortfolio: {
			openActions: {
				title: '{count} offene Maßnahmen für meine Prioritätsverträge',
				plannedActions: {
					title: 'Geplant',
					tooltip: '{count} geplante Maßnahmen',
				},
				overdueActions: {
					title: 'Überfällig',
					tooltip: '{count} überfällige Maßnahmen',
				},
				button: 'Alle Maßnahmen anzeigen',
			},
			priorityContracts: {
				title: 'Meine offenen Prioritätsverträge',
				noActionPlanned: 'Verträge ohne geplante Maßnahmen',
				highValue: 'Hoher Wert / Risiko',
				lowValue: 'Niedriger Wert',
				manually: 'Manuell hinzugefügt',
				nbContracts: '{nb} Verträge',
			},
			followUp: {
				title: 'Vertragsnachverfolgung',
				openActions: {
					title: '{count} Maßnahmen',
					planned: {
						title: 'Geplant',
						tooltip: '{count} geplante Maßnahmen',
					},
					overdue: {
						title: 'Überfällig',
						tooltip: '{count} überfällige Maßnahmen',
					},
				},
				forecasts: {
					title: 'Kündigungsprognose',
					high: {
						title: 'Hohe Wahrscheinlichkeit',
						tooltip: '{count} Hohe Wahrscheinlichkeit',
					},
					low: {
						title: 'Geringe Wahrscheinlichkeit',
						tooltip: '{count} Geringe Wahrscheinlichkeit',
					},
				},
				button: 'Alle anzeigen',
			},
		},
		srOverview: {
			title: {
				mobile: 'SV-Verk. – Übersicht',
				desktop: 'SV-Verk. – Übersicht (Prioritätsverträge)',
			},
			breadcrumbs: {
				dashboard: 'Team-Dashboard',
				srOverview: 'SV-Verk. – Übersicht',
			},
			row: {
				title: '{openContracts} offene Verträge,{totalContracts} gesamt ({openContractsPercentage}%)',
				subtitle: '{nbActions} ohne Aktionen',
			},
			table: {
				headers: {
					lastName: 'Vertrieb',
					openContractsCount: {
						title: 'Offene Verträge',
						text: '{nbContracts} ohne Maßnahmen',
					},
					openActionsCount: {
						title: 'Verbleibende Maßnahmen',
						text: '{nbActions} Maßnahmen überfällig',
					},
					overdueCount: 'Überfällige Verträge',
					toBeCancelled: 'Wird gekündigt',
					toBeAutoRenewed: 'Wird verlängert',
					renegotiated: 'Neu Verhandelt',
					upgraded: 'Aktualisiert',
					downgraded: 'Heruntergestuft',
					openActions: {
						title: 'Offene Maßnahmen',
						text: '{nbActions} überfällig',
					},
					overdueContracts: 'Überfällige Verträge',
				},
				noResult: 'Kein(e) SV-Verk. gefunden',
			},
		},
		reporting: { // FIXME
			month: {
				[MONTH.JANUARY]: 'January',
				[MONTH.FEBRUARY]: 'February',
				[MONTH.MARCH]: 'March',
				[MONTH.APRIL]: 'April',
				[MONTH.MAY]: 'May',
				[MONTH.JUNE]: 'June',
				[MONTH.JULY]: 'July',
				[MONTH.AUGUST]: 'August',
				[MONTH.SEPTEMBER]: 'September',
				[MONTH.OCTOBER]: 'October',
				[MONTH.NOVEMBER]: 'November',
				[MONTH.DECEMBER]: 'December'
			},
			filters: {
				level: {
					all: {
						[LEVEL.REGION]: 'All regions',
						[LEVEL.BRANCH]: 'All branches',
						[LEVEL.SALES_REP]: 'All sales reps',
						default: 'Perimeter'
					},
					[LEVEL.REGION]: 'Regions',
					[LEVEL.BRANCH]: 'Branches',
					[LEVEL.SALES_REP]: 'Sales Reps',
					[LEVEL.USER]: 'Sales Rep',
					default: 'Perimeter'
				},
				year: 'Year',
				view: {
					label: 'Display model',
					[VIEW.MONTHLY]: {
						performance: 'Monthly view',
						adoption: 'Monthly view'
					},
					[VIEW.YEAR_TO_DATE]: {
						performance: 'Year To Date',
						adoption: 'Monthly average'
					}
				}
			},
			tabBar: {
				adoption: 'Adoption',
				activity: 'Activity',
				performance: 'Performance'
			},
			teams: {
				title: 'Teams',
				graph: {
					performance: {
						title: '% of contracts saved VS contracts lost',
						legend : 'YTD %'
					},
					activity: {
						title: '% of contracts with overdue actions',
						legend : 'YTD %'
					},
					adoption: {
						title: 'Adoption overview',
						legend : '% of contracts with actions + contracts closed vs total contracts at risk'
					}
				}
			},
			detailed: {
				title: 'Monthly Reporting',
				perimeter: 'Perimeter',
				graph: {
					title: 'Contracts saved',
					value: 'Value',
					units: 'Units'
				}
			},
			noResult: 'No data found',
			performance: {
				table: {
					tooltip : {
						savedContracts : 'Contracts closed as Renegotiated and Extended',
						lostContracts: 'Contracts closed as cancelled',
						savedContractsRate: 'Contracts saved vs contracts lost',
						renegociatedContractsRate: 'Contracts renegotiated vs total of contracts closed',
					},
					month: 'Month',
					savedContracts : '<baliseToolTip>Contracts saved {br} (Units/value)</baliseToolTip>',
					lostContracts: '<baliseToolTip>Contracts lost {br} (Units/value)</baliseToolTip>',
					savedContractsRate: '<baliseToolTip>Contracts saved rate {br} (Units/value)</baliseToolTip>',
					renegociatedContracts: 'Contracts renegotiated {br} (Units/value)',
					renegociatedContractsRate: '<baliseToolTip>Contracts renegotiated rate {br} (Units/value)</baliseToolTip>',
					total: 'Total'
				},
				tooltip : {
					good: '% of contracts saved > 95%',
					bad: '% of contracts saved < 80%'
				}
			},
			activity: {
				table: {
					day: 'Day',
					noActionsContracts : 'Contracts without actions {br} (Units/value)',
					contractsWithActions: 'Contracts with actions {br} (Units/value)',
					contractsWithActionsRate: 'Contracts % with actions',
					contractsWithOverdueActionsRate: 'Contracts % with overdue actions',
					contractsWithHelpRequested: 'Contracts with manager help requested',
					total: 'Total'
				},
				tooltip : 'At least 50% of open contracts should have an action'
			},
			adoption: {
				table: {
					month: 'Month',
					nbConnexion : 'Connection to RTV (# of days)',
					nbChangementsActions: '# of actions updated or modified',
					nbActionsOuvertes: '# of action opened in the month',
					nbChangementsDate: '# of actions deadlines changed',
					nbAjoutContrats: '# of contracts added manually',
					total: 'Total'
				},
				tooltip : 'High number of actions deadlines changed'
			},
			level : {
				[LEVEL.COUNTRY]: 'Countries',
				[LEVEL.REGION]: 'Regions',
				[LEVEL.BRANCH]: 'Branches',
				[LEVEL.SALES_REP]: 'Sales Representatives',
				[LEVEL.USER]: 'Sales Representative',
			}
		},
	},
	valueIcon: {
		high: 'Prioritätsvertrag mit hohem Wert-/Risiko seit {month}/{year}',
		low: 'Prioritätsvertrag mit niedrigem Wert seit {Month}/{year}',
		manually: 'Manuell zur Prioritätenliste hinzugefügt',
	},
	router: {
		error: {
			title: 'API-Verbindung unterbrochen',
			content: 'Aktualisieren Sie die Seite, oder melden Sie sich erneut an.',
		},
	},
	profiles: {
		ZONE_MANAGER: 'EMEA',
		NATIONAL: 'National',
		BRANCH_MANAGER: 'Niederlassungsleiter',
		SALES_REPRESENTATIVE: 'SV-Verk.',
		BRANCH_MANAGER_ASSISTANT: 'Assistent des Niederlassungsleiters',
		REGIONAL_MANAGER: 'Regionalmanager',
	},
	actionButton: {
		cancel: 'Abbrechen',
	},
	language: {
		fr: 'Französisch',
		en: 'Englisch',
		cze: 'Tschechisch',
		de: 'Deutsch',
		sp: 'Spanisch',
		pt: 'Portugiesisch',
		ita: "Italienisch"
	},
	action: {
		filters: {
			all: 'Alle Maßnahmen Anzeigen',
			open: 'Offene Maßnahmen Anzeigen',
			closed: 'Geschlossene Maßnahmen Anzeigen',
		},
		form: {
			select: 'Maßnahme auswählen...',
			comparison: 'Dieser Vertrag ist zu spezifisch für einen Preisvergleich',
			type: 'Maßnahmentyp',
			deadline: 'Deadline',
			description: 'Beschreibung',
		},
		page: {
			title: 'Übersicht über die Maßnahmen von {firstName} {lastName}',
			defaultTitle: 'Maßnahmenübersicht',
			breadcrumbs: {
				dashboard: 'Team-Dashboard',
				srOverview: 'SV-Verk.-Übersicht',
				repPortfolio: 'Portfolio von {firstName} {lastName}',
				actionsOverview: 'Maßnahmenübersicht',
				myPortfolio: 'Mein Portfolio',
			},
			list: {
				noResult: 'Keine Maßnahmen gefunden',
				headers: {
					action: 'Maßnahme',
					status: 'Status',
					description: 'Beschreibung',
					deadline: 'Deadline',
				},
				tooltip: 'Maßnahme überfällig',
				button: 'Vertrag anzeigen',
			},
			table: {
				searchBar: 'Suche nach Kunde, Vertrags-ID oder Beschreibung',
				filters: {
					type: 'Maßnahmentyp...',
				},
			},
		},
		contract: {
			searchBar: 'Suche nach Maßnahmenbeschreibung',
			addButton: 'Neue Maßnahme hinzufügen',
			noResult: 'Keine Maßnahme gefunden',
			openBy: 'Geöffnet von {firstName} {lastName}',
			closedOn: 'Geschlossen am {date} von {firstName} {lastName}',
			lastModified: 'Zuletzt geändert am {date} von {firstName} {lastName}',
			button: {
				update: 'Maßnahme aktualisieren',
				close: 'Maßnahme abschließen',
			},
			confirmation: {
				title: 'Bestätigung des Maßnahmenabschlusses',
				content: 'Maßnahme abschließen?',
				buttonLabel: 'Maßnahme abschließen',
			},
			new: {
				title: 'MASSNAHME',
				buttonLabel: 'Maßnahme ergreifen',
				cancel: 'Abbrechen',
			},
			update: {
				title: 'MASSNAHME',
				buttonLabel: 'Speichern',
			},
			deadline: 'Deadline',
		},
		status: {
			all: 'Alle Maßnahmen',
			open: {
				label: 'Offene Maßnahmen',
				chipLabel: 'Offen',
			},
			closed: {
				label: 'Abgeschlossene Maßnahmen',
				chipLabel: 'Abgeschlossen',
			},
		},
		type: {
			all: {
				label: 'Alle Arten',
			},
			[ACTION_TYPE.FIRST_CALL]: {
				label: 'Erster Anruf',
				defaultDescription: 'Kunde anrufen, um die Zufriedenheit zu überprüfen',
			},
			[ACTION_TYPE.CUSTOMER_MEETING]: {
				label: 'Kundengespräch / Treffen mit dem Kunden',
				defaultDescription: 'Den Kunden treffen, um die Beziehung zu verbessern und den Vertrag zu besprechen',
			},
			[ACTION_TYPE.REPORT_TO_CUSTOMER]: {
				label: 'Meldung an den Kunden',
				defaultDescription: 'Informationen mit dem Kunden teilen, um die Zufriedenheit zu verbessern',
			},
			[ACTION_TYPE.PROACTIVE_PROPOSAL]: {
				label: 'Proaktives Angebot',
				defaultDescription: 'Angebot unterbreiten, um den Vertrag zu verlängern',
			},
			[ACTION_TYPE.RENEGOTIATION]: {
				label: 'Neuverhandlung',
				defaultDescription: 'Ein vom Kunden angefordertes Angebot für einen neuen Vertrag unterbreiten',
			},
			[ACTION_TYPE.DOWNSELL]: {
				label: 'Downsell',
				defaultDescription: 'Vorschlagen, den Vertrag herunterzustufen, um wettbewerbsfähig zu bleiben',
			},
			[ACTION_TYPE.UPSELL]: {
				label: 'Upselling',
				defaultDescription: 'Vorschlag zum Vertragsupgrade, um den Vertragswert zu erhöhen',
			},
			[ACTION_TYPE.SEND_MECHANIC_TO_JOBSITE]: {
				label: 'Einen Monteur zum Objekt schicken',
				defaultDescription: 'Ein technisches Problem am Gerät beheben',
			},
			[ACTION_TYPE.SEND_SUPERVISOR_TO_JOBSITE]: {
				label: 'Aufsichtsperson zur Baustelle schicken',
				defaultDescription: 'Wartung an der Unit durchführen, um das Störungsrisiko zu minimieren',
			},
			[ACTION_TYPE.CONTACT_SUPERVISOR_MECHANIC]: {
				label: 'Verantwortlichen Monteur kontaktieren',
				defaultDescription: 'Technischen Zustand der Unit überprüfen',
			},
			[ACTION_TYPE.OTHER]: {
				label: 'Andere',
			},
			[ACTION_TYPE.CUSTOMER_CLAIM]: {
				label: 'Kundenforderung verwalten',
			},
			[ACTION_TYPE.CANCELLATION_REQUEST]: {
				label: 'Kündigungsbegehren verwalten',
			},
		},
	},
	user: {
		new: {
			title: 'User anlegen',
			buttonLabel: 'Erstellen',
		},
		update: {
			title: 'Benutzeränderung',
			buttonLabel: 'Aktualisieren',
		},
		form: {
			errors: {
				required: 'Erforderlich',
				invalidFormat: 'Unzulässiges Format',
				max255char: 'Maximal 255 Zeichen',
				emailExists: 'Diese E-Mail existiert bereits.',
				emailInactive: 'Diese E-Mail ist derzeit inaktiv.',
			},
			fields: {
				lastName: 'Nachname *',
				firstName: 'Vorname *',
				email: 'E-Mail *',
				profile: 'Profil',
				country: 'Land',
				branches: 'Niederlassung(en)',
				region: 'Region',
			},
		},
		table: {
			headers: {
				lastName: 'Nachname',
				firstName: 'Vorname',
				email: 'E-Mail',
				branch: 'Niederlassung(en)',
				profile: 'Profil',
				country: 'Land',
				region: 'Region',
			},
			actions: {
				reactivate: 'Reaktivieren',
				modify: 'Ändern',
				deactivate: 'Deaktivieren',
			},
			filters: {
				searchBar: 'Nach Benutzername, E-Mail oder Zweigstelle filtern',
				select: {
					placeholder: 'Profil',
					all: 'Alle Profile',
					national: 'Großkunde(n)',
					branchManager: 'Niederlassungsleiter',
					branchManagerAssistant: 'Niederlassungsleiter-Assistenz',
					salesRepresentative: 'SV-Verk.',
					regionalManager: 'Regionaler Vertriebsleiter',
				},
				switch: 'Deaktivierte Benutzer anzeigen',
				reset: 'ZURÜCKSETZEN',
			},
		},
		menu: {
			myAccount: 'Mein Konto',
			quit: 'Beenden',
		},
	},
	errors: {
		mandatory: 'Pflichtfeld',
		onlyFutureDate: 'Nur zukünftiges Datum',
	},
	countries: {
		table: {
			headers: {
				name: 'Name',
				lowValueThreshold: 'Niedriger Schwellenwert',
				highRiskValueThreshold: 'Schwellenwert für hohen Risikowert',
				lowValueAmount: 'Anzahl geringwertiger Verträge',
				highRiskValueAmount: 'Anzahl hochwertiger Verträge',
				refresh: 'Beim Import aktualisieren',
				forecastModule: 'Forecast-Modul',
			},
			actions: {
				modify: 'Modifikator',
			},
			values: {
				false: 'Nein',
				true: 'Ja',
			},
		},
		dialog: {
			title: 'Länderanpassung',
			labels: {
				name: 'Name *',
				lowValueThreshold: 'Niedriger Schwellenwert *',
				highRiskValueThreshold: 'Schwellenwert für hohen Risikowert *',
				lowValueAmount: 'Niedriger Vertragsbetrag *',
				highRiskValueAmount: 'Vertragsbetrag mit hohem Risikowert *',
				refresh: 'Beim Import aktualisieren *',
				forecastModule: 'Prognosemodul *',
                usdConversionRate: 'Conversion rate to $USD'
            },
			values: {
				false: 'Nein',
				true: 'Ja',
			},
			actions: {
				cancel: 'Abbrechen',
				update: 'Aktualisieren',
			},
			errors: {
				required: 'Erforderlich',
				negative: 'Der Wert muss größer als 0 sein',
				maximum: 'Der Wert muss kleiner als 1000 sein',
			},
		},
	},
	forecasts: {
		page: {
			title: 'Prognoseübersicht von {firstName} {lastName}',
			defaultTitle: 'Prognoseübersicht',
			breadcrumbs: {
				dashboard: 'Team-Dashboard',
				srOverview: 'SV-Verk.-Übersicht',
				repPortfolio: 'Portfolio von {firstName} {lastName}',
				forecastsOverview: 'Prognoseübersicht',
				myPortfolio: 'Mein Portfolio',
			},
			list: {
				noResult: 'Keine Prognose gefunden',
				searchBar: 'Suche nach Kunden- oder Vertrags-ID',
				headers: {
					contract: 'Vertrag ({contractNumber})',
					status: 'Status',
					units: 'Units ({unitsNumber})',
					unitsEmpty: 'Units',
					probability: 'Prognose',
					cancellationMonth: 'Kündigungsmonat',
				},
				information: {
					status: {
						TODO: 'KEINE MASSNAHME',
						IN_PROGRESS: 'WIRD BEARBEITET',
						TO_BE_CANCELLED: 'WIRD GEKÜNDIGT',
						TO_BE_AUTO_RENEWED: 'WIRD VERLÄNGERT',
						RENEGOTIATED: 'NEU VERHANDELT',
						UPGRADED: 'AKTUALISIERT',
						DOWNGRADED: 'HERUNTERGESTUFT',
					},
					cancellationMonth: {
						old: 'Veraltete Prognose',
					},
				},
			},
		},
		probability: {
			all: {
				label: 'Hohe + Geringe Wahrscheinlichkeit',
			},
			[FORECAST_PROBABILITY.LOW]: {
				label: 'Geringe Wahrscheinlichkeit',
			},
			[FORECAST_PROBABILITY.HIGH]: {
				label: 'Hohe Wahrscheinlichkeit',
			},
		},
		cancellationMonth: {
			all: {
				label: 'Alle Monate',
			},
			outdated: {
				label: 'Veraltet',
			},
		},
	},
	import: {
		form: {
			country: {
				label: 'Land',
				errors: {
					required: 'Erforderlich',
				},
			},
			file: {
				label: 'Datei',
				empty: 'Keine Datei',
				button: 'Datei auswählen',
				errors: {
					required: 'Erforderlich',
					wrongFormat: 'Falsches Dateiformat',
				},
			},
			submit: 'Importieren',
		},
		results: {
			header: {
				added: 'Anzahl der hinzugefügten Benutzer: {count}',
				errors: 'Anzahl der Fehler: {count}',
			},
			success: 'Hinzugefügter Benutzer: {E-Mail}',
			errors: {
				regionMissing: 'Region-ID fehlt',
				branchNotInRegion: 'Niederlassung in der angegebenen Region nicht gefunden',
				branchNotFound: 'Niederlassung nicht gefunden',
				regionNotFound: 'Region nicht gefunden',
				branchMissing: 'Niederlassungs-ID fehlt',
				profile: 'Profil nicht gefunden',
				noRegionInCountry: 'Keine Region in diesem Land',
				emailFormat: 'Falsches E-Mail-Format',
				emailMissing: 'Zeile {line}: E-Mail nicht gefunden',
				emailMissingExtended: 'Zeile {line} - {Name}: E-Mail nicht gefunden',
				wrongProfile: 'Keine Übereinstimmung mit Datenbankprofil',
			},
		},
	},
	crm: {
		btn: 'Run contract export to CRM Italy',
		success: 'Success of exporting contract to CRM Italy',
		error: 'Error while exporting contract to CRM Italy',
		loading: 'Exporting contract to CRM Italy...',
		date: {
			title: 'Date',
			helperText: 'Required format : dd-mm-yyyy',
			invalid: 'Invalid format'
		}
	}
})
